import { useTranslation } from "react-i18next";
import classNames from "classnames/bind";
import classes from "./ErrorPage.module.scss";
import { BaseButton } from "@velocity-ehs/component-library";
import { useHistory } from "react-router-dom";

const { errorContainer, tagLine, description, action, image } = classes;

const ErrorPage = () => {
  const cx = classNames.bind(classes);
  const { t } = useTranslation();
  const history = useHistory();

  return (
    <div className={cx(errorContainer)}>
      <div className={cx(image)}>{/* Insert Image Here */}</div>
      <div className={cx(tagLine)}>
        <h2>{t("error_page_tag_line")}</h2>
      </div>
      <div className={cx(description)}>
        <p>{t("error_page_description")}</p>
      </div>
      <div className={cx(action)}>
        <BaseButton
          type="button"
          onClick={() => {
            if (history.length > 0) {
              history.goBack();
            } else {
              history.push("/");
            }
          }}
          label={t("error_page_action")}
        />
      </div>
    </div>
  );
};

export default ErrorPage;
